var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.type+'--alert mt-3'},[_c('v-alert',{staticClass:"mb-0 grey lighten-4",attrs:{"dense":"","outlined":"","type":_vm.type,"dismissible":"","close-text":"Close Alert"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }